import React, { lazy } from 'react'
import { Route } from 'react-router-dom';
import ChangePassword from '../pages/Dashboard/ChangePassword.js';
const YourTeams = lazy(() => import('../pages/Dashboard/YourTeams.js'));
const YourTeamDetails = lazy(() => import('../pages/Dashboard/YourTeamDetails.js'));
const Setting = lazy(() => import('../pages/Dashboard/Setting.js'));
const DraftRegisterPage = lazy(() => import('../pages/Dashboard/DraftRegisterPage.jsx'));
const PlayerProfile = lazy(() => import('../pages/Dashboard/PlayerProfile.jsx'));

const PlayerRoutes = (
    <>
        <Route exact path='/dashboard/profile' element={<PlayerProfile />}></Route>
        <Route exact path='/dashboard/yourteam' element={<YourTeams />}></Route>
        <Route exact path='/dashboard/yourteam/:id' element={<YourTeamDetails />}></Route>
        <Route exact path='/dashboard/user/setting' element={<Setting />}></Route>
        <Route exact path='/dashboard/user/change-password' element={<ChangePassword />}></Route>

            {/* Internal draft registration — stays inside the app shell */}
        <Route exact path='/dashboard/draft/register/:slug' element={<DraftRegisterPage />} />


    </>
)

export default PlayerRoutes